//
import Service from '@/services/api/service'
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrder'

//
import fields           from './fields'
import filters          from './filters'
import headers          from './headers'
import headersDetail    from './headersDetail'
import headersPending   from './headersPending'
import includes         from './includes'

//
export default class extends Service {

    //
    static fields           = fields
    static filters          = filters
    static headers          = headers
    static headersDetail    = headersDetail
    static headersPending   = headersPending
    static includes         = includes
    
    //
    static model = PurchaseOrderModel
}
